import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';

export default function EvntCard({ evnt, evntRef, arrowDownRef, arrowUpRef, foldHandler }: any) {

  return (
    <>
      <button
        onClick={() => foldHandler(evnt.evntNm)}
        className='flex justify-between items-center border-none w-[255px] sm:w-[318px] md:w-[750px] h-68 md:h-[170px] rounded-[5px] md:rounded-[12px] mt-17 md:mt-[42px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-2 w-[155px] sm:w-[210px] md:w-[525px]'>
          <p className='ml-25 md:ml-[62px] text-13 sm:text-15 md:text-37 font-preBold truncate'>{evnt.evntNm}</p>
          <p className='text-12 sm:text-14 md:text-35 text-left font-preLight truncate text-[#868686]'>{ }</p>
        </div>
        <div ref={(el) => arrowDownRef.current[evnt.evntNm] = el}><IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' /></div>
        <div hidden ref={(el) => arrowUpRef.current[evnt.evntNm] = el}><IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' /></div>
      </button>
      <div hidden ref={(el) => evntRef.current[evnt.evntNm] = el}>
        <div className='flex items-center mt-15 md:mt-[37px] ml-10 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
          <p className='font-preBold mr-20 md:mr-[50px]'>준비기간</p>
          <p>{evnt.prepStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{evnt.prepEndDt}</p>
        </div>
        <div className='flex items-center mt-13 md:mt-[32px] ml-10 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
          <p className='font-preBold mr-20 md:mr-[50px]'>행사기간</p>
          <p>{evnt.evntStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{evnt.evntEndDt}</p>
        </div>
        <div className='flex items-center mt-13 md:mt-[32px] ml-10 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
          <p className='font-preBold mr-20 md:mr-[50px]'>철거기간</p>
          <p>{evnt.dmlnStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{evnt.dmlnEndDt}</p>
        </div>
        <div className='flex items-center mt-13 md:mt-[32px] ml-10 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
          <p className='font-preBold mr-20 md:mr-[50px]'>전시장소</p>
          <p>{evnt.exbtPlc}</p>
        </div>
        <div className='flex items-center mt-13 md:mt-[32px] ml-10 sm:ml-18 md:ml-[45px] font-preLight text-14 md:text-35'>
          <p className='font-preBold mr-8 md:mr-[20px]'>안전관리자</p>
          <p>{evnt.wrkrs}</p>
        </div>
      </div>
    </>
  );
}

